import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=fdb7fd3c&"
import script from "./SelectOption.vue?vue&type=script&lang=js&"
export * from "./SelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports